import React from 'react';

class Callmom extends React.Component {

  render() {
    return(
      <span>Call your mom (partner / friend / kid... ) and ask her if she ever heard of {this.props.term} and if yes what she thinks about it. Listen carefully to not just the words, but also the emotions behind.</span>
    )
  }

}

export default Callmom;
